export default "__VITE_ASSET__DOKnJ3iI__"